<template>
    <div>
        <section class="section">
            <p><strong>Witamy na formularzu e-konsultacji. Uzupełnij prawidłowo wszystkie pola aby zapisać się na zdalne konsultacje.<br />
                Szczegóły na temat zapisu na e-konsultacje znajdziesz <a href="https://czasnawzrok.pl/e-konsultacja/" target="_blank">tutaj</a>.</strong>
            <br /><br /></p>
            <div class="field">
                <label class="label required">Wybierz formę kontaktu</label>
                <div class="field">
                    <label class="checkbox ">
                        <input v-model="videoContact" type="checkbox">
                        <span :class="{'is-danger-checkbox': errors.videoContact}"> Videorozmowa</span>
                    </label>
                </div>
                <div class="field">
                    <label class="checkbox">
                        <input v-model="telephoneContact"
                               type="checkbox">
                        <span :class="{'is-danger-checkbox': errors.telephoneContact}"> Rozmowa telefoniczna </span>
                    </label>
                </div>
            </div>

            <hr>
            <section class="">
                <p><strong class="required">Podaj przynajmniej jedną informację jak możemy się z Tobą skontaktować</strong><br /><br /></p>
                <div class="field">
                    <label class="label">Numer telefonu</label>
                    <div class="control">
                        <input class="input" :class="{'is-danger': errors.telephone}" type="number" v-model="telephone"
                               placeholder="Numer telefonu">
                    </div>
                </div>

                <div class="field">
                    <label class="label">WhatsApp</label>
                    <div class="control">
                        <input class="input" :class="{'is-danger': errors.telephone}" type="number" v-model="whatsapp"
                               placeholder="Numer telefonu">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Adres Twojego profilu Facebook</label>
                    <div class="control">
                        <input class="input" :class="{'is-danger': errors.facebookAddress}" v-model="facebookAddress"
                               type="text" placeholder="Podaj adres swojego profilu">
                    </div>
                </div>
            </section>
            <hr>
            <section class="">
                <div class="field">
                    <label class="label required"> Podaj nam preferowaną datę kontaktu
                    </label>
                    <div class="field">
                        <p v-if="errors.dateError" class="help is-danger">Możemy skontaktowa się z Tobą od dnia
                            jutrzejszego</p>
                        <div class="control">
                            <datepicker :input-class="'input'" :disabled-dates="state.disabledDates" :language="pl" v-model="date" monday-first></datepicker>
                        </div>
                    </div>
                </div>

                <div class="field ">
                    <label class="label">Zakres godzin</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" name="member" checked>
                            11-14
                        </label>
                    </div>
                </div>

            </section>
            <hr>
            <section class="">
                <div class="field">
                    <label class="label required">Twoje imię</label>
                    <div class="control">
                        <input class="input" :class="{'is-danger': errors.name}" type="text" v-model="name"
                               placeholder="Imię">
                    </div>
                </div>
                <div class="field">
                    <label class="label required">Twój adres e-mail</label>
                    <div class="control">
                        <input class="input" :class="{'is-danger': errors.email}" type="email" v-model="email"
                               placeholder="E-mail">

                    </div>
                </div>
            </section>
            <hr>
            <section class="">
                <div class="field ">
                    <div class="field">
                        <label class="checkbox required">
                            <input type="checkbox" v-model="serviceRegulations">
                            <span :class="{'is-danger-checkbox': errors.serviceRegulations}">
                                             Oświadczam, że zapoznałam/-em się z <a
                                    href="https://czasnawzrok.pl/wp-content/uploads/2020/05/regulamin-e-konsultacje.pdf"
                                    target="_blank">Regulaminem świadczenia usług</a> i go akceptuję na potrzeby przeprowadzenia E-konsultacji możliwej do zrealizowania po wysłaniu wypełnionego formularza dostępnego na lokalizatorze optyków..</span>
                        </label>
                    </div>
                </div>
            </section>
            <hr>
            <section class="">
                <div class="field">
                    <p>Informujemy, że jako Grupa Essilor dokonujemy współadministrowania Pani/Pana danymi osobowymi w przesłanym formularzu rejestracyjnym dla celów związanych z zarządzaniem zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych. Informujemy, że niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym będzie przeprowadzana e – konsultacja. Więcej informacji, w tym o przysługujących Pani/Panu prawach oraz o zasadniczej treści uzgodnień jakie poczyniliśmy w ramach współadministrowania Pani/Pana danymi osobowymi znajduje się w naszej <a href="https://czasnawzrok.pl/polityka-prywatnosci/" target="_blank">Polityce prywatności</a>. W skład Grupy Essilor wchodzą: Essilor Polonia Sp. z o.o., JZO S.A. oraz JAI KUDO Polska Sp. z o.o.</p>

                </div>
            </section>
            <hr>
            <br>
            <article v-show="this.formErrors" class="message is-danger">
                <div class="message-header">
                    Formularz zawiera błędy, które należy poprawić. Szczegóły znajdziesz przy każdym z błędnie
                    wypełnionych pól.

                </div>
            </article>
            <div class="locator__place-extended-download ">
                <h3 class="locator__place-extended-title"><a @click="submitForm()" href="#" class="btn">UMÓW SIĘ NA E-KONSULTACJĘ</a></h3>
            </div>

        </section>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {pl, lt} from 'vuejs-datepicker/dist/locale'
    import axios from 'axios'

    export default {
        name: "conference-form",
        props: ['institutionId'],
        components: {
            Datepicker,
        },
        data() {
            return {
                state: {
                    disabledDates: {
                        to: new Date(),
                        days: [6, 0]
                    }
                },
                pl: {pl, lt}[this.$appLang.toLowerCase()],
                videoContact: false,
                telephoneContact: false,
                facebookAddress: '',
                whatsapp: '',
                telephone: '',
                date: new Date(),
                name: '',
                calendar: '',
                hour_range: '11-14',
                leadType: 'e-consultation',
                email: '',
                serviceRegulations: false,
                mailMarketing: false,
                smsMarketing: false,
                telephoneMarketing: false,
                webCommunicatorsMarketing: false,
                formErrors: false,
                errors: {
                    serviceRegulations: false,
                    videoContact: false,
                    telephoneContact: false,
                    contactMethod: false,
                    name: false,
                    facebookAddress: false,
                    telephone: false,
                    whatsapp: false,
                    email: false,
                    dateError: false
                }
            };
        }, mounted() {

            const tomorrow = new Date(this.date)
            tomorrow.setDate(tomorrow.getDate() + 1)
            this.date = tomorrow
        },
        methods: {
            checkAgreements() {
                this.mailMarketing = true;
                this.smsMarketing = true;
                this.telephoneMarketing = true;
                this.webCommunicatorsMarketing = true;
            },
            submitForm() {

                if (false === this.validate()) {
                    return false;
                }

                let payload = {
                    'videoContact': this.videoContact,
                    'telephoneContact': this.telephoneContact,
                    'facebookAddress': this.facebookAddress,
                    'telephone': this.telephone,
                    'whatsapp': this.whatsapp,
                    'name': this.name,
                    'date': this.date,
                    'leadType': this.leadType,
                    'email': this.email,
                    'serviceRegulations': this.serviceRegulations,
                    'mailMarketing': this.mailMarketing,
                    'smsMarketing': this.smsMarketing,
                    'telephoneMarketing': this.telephoneMarketing,
                    'webCommunicatorsMarketing': this.webCommunicatorsMarketing,
                    'institution': this.institutionId,
                    'lang': this.$appLang.toLowerCase()   
                }

                let locatorSlug = this.$siteVariantName;
                var that = this;
                axios.post(`/leads/${locatorSlug}/save`, payload)
                    .then(function (response) {
                        that.$emit("form-result", true);
                    })
                    .catch(function (error) {
                        error = error.response.data;
                        console.log(error)
                        if (error.hasOwnProperty('errors')) {
                            for (let errors in error.errors.children) {
                                let child = error.errors.children[errors];
                                if (!child.hasOwnProperty('errors')) {
                                    continue;
                                }
                                that.setError(errors);
                                return;
                            }

                        }
                        that.$emit("form-result", false);
                    });
            },
            setError(key) {
                if (this.errors.hasOwnProperty(key)) {
                    this.errors[key] = true
                }
            },
            validate() {
                this.formErrors = false;
                for (let error in this.errors) {
                    this.errors[error] = false
                }

                if (this.serviceRegulations == false) {
                    this.errors.serviceRegulations = true
                }


                if (this.videoContact == false && this.telephoneContact == false) {
                    this.errors.videoContact = true
                    this.errors.telephoneContact = true
                }


                if (this.facebookAddress == "" && this.whatsapp == "" && this.telephone == "") {
                    this.errors.facebookAddress = true
                    this.errors.whatsapp = true
                    this.errors.telephone = true
                }


                let today = new Date();
                if (this.date < today) {
                    this.errors.dateError = true
                }


                let toValidate = [
                    'date', 'name', 'email'
                ];
                let that = this;


                toValidate.forEach((el) => {
                    if ("" == that[el]) {
                        that.errors[el] = true
                    }
                });

                for (let error in this.errors) {
                    if (this.errors[error]) {
                        this.formErrors = true
                        return false;
                    }
                }

                return true;

            }
        },
    }
</script>

<style>
    .vdp-datepicker__calendar .up {
        transform: rotate(0deg) !important;
        -webkit-transform: rotate(0deg) !important;
    }
</style>
